/**
 * Similar to Object.assign, but it also considers nested objects.
 *
 * @example
 * deepAssign(
 *   { foo: { animal: 'dog' }, bar: 1 },
 *   { foo: { color: 'black'}, bar: 2 }
 * );
 * => {
 *   foo: { animal: 'dog', color: 'black' },
 *   bar: 2
 * }
 *
 * @param  {...any} args - List of objects to deep-assign
 * @returns {any} - The deep-assigned result
 */

const deepAssign = (...args) => {
  return args.reduce((result, object) => {
    Object.entries(object).forEach(([key, value]) => {
      if(
        result[key] !== null &&
        typeof result[key] === 'object' &&
        !Array.isArray(result[key])
      ) {
        deepAssign(result[key], value)
      } else {
        result[key] = value;
      }
    });
    return result;
  });
}

export default deepAssign;
export { deepAssign };
